export default "__VITE_ASSET__DLd6jQ7$__"